import { Directive, HostBinding } from '@angular/core';
import { AuthService } from '@services/security';

@Directive({
    selector: '[appDisabledForNonAdmin]',
})
export class DisableForNonAdminDirective {
    constructor(private authService: AuthService) {}

    disabledForNonAdmin = !this.authService.isAdmin;

    @HostBinding('attr.disabled')
    get disabledAttr(): '' | null {
        return this.disabledForNonAdmin ? '' : null;
    }
}
